import { useI18n } from '../../i18n'
import { featureFlags } from '../../config/featureFlags'
import { useRestrictedVisibility } from '../../hooks/useRestrictedVisibility'

export default function RestrictedScopeBanner({ className = '' }: { className?: string }) {
  const { t } = useI18n()
  const { restrictedMode, allowedStandards } = useRestrictedVisibility()

  if (!featureFlags.STANDARD_SCOPE_VISIBILITY_V1 || !restrictedMode) {
    return null
  }

  const standards = allowedStandards.join(', ')

  return (
    <div
      className={`flex items-center gap-2 text-xs px-3 py-1.5 rounded-md bg-slate-100 border border-slate-200 text-slate-700 ${className}`}
      title={t(
        'standardGovernance.restrictedMetricsTooltip',
        'Metrics are limited to assigned standards and related systems.',
      )}
    >
      <span className="font-medium">
        {t('standardGovernance.restrictedComplianceScope', 'Restricted compliance scope')}
      </span>
      {standards ? <span className="text-slate-500">({standards})</span> : null}
    </div>
  )
}
